import {Avatar} from 'platform/components';
import {HStack, Box, VStack, Heading, Space, Clickable, Show, Hide} from 'platform/foundation';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {GetConversationEventsResponse} from '@chat/shared/validations';
import {RichContentDisplay} from '@chat/ui';

import {EventDate, EventDateProps} from './EventDate';
import {Text} from './richContent/Text';
import {WhatsappTextLink} from './WhatsappTextLink';

interface CustomerMessageProps extends Pick<EventDateProps, 'messageStatus' | 'showReadStatus'> {
  event: GetConversationEventsResponse[number];
  onMediaClick?: () => void;
}

export function CustomerMessage(props: CustomerMessageProps) {
  return (
    <HStack width="100%" justify="flex-start" spacing={1}>
      <Avatar name={props.event.sender.displayName} size="xSmall" />
      <VStack spacing={1} width="fit-content">
        <HStack width="100%">
          <svg
            width="6"
            height="16"
            viewBox="0 0 6 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.47214 -6.67851e-08L6 0L6 16L0.894427 5.78885C-0.435375 3.12925 1.49861 -1.96762e-07 4.47214 -6.67851e-08Z"
              fill="#EBECF0"
            />
          </svg>
          <Box
            backgroundColor="palettes.neutral.30.100"
            padding={3}
            borderTopRightRadius="medium"
            borderBottomLeftRadius="medium"
            borderBottomRightRadius="medium"
            width="100%"
          >
            <VStack spacing={1} width="100%">
              <Heading size={5} align="left" color="primary">
                {props.event.sender.displayName}
              </Heading>
              <div>
                <Show when={isNotNilOrEmpty(props.event.mediaId)}>
                  <Clickable onClick={props.onMediaClick}>
                    <WhatsappTextLink isClickable={Boolean(props.onMediaClick)}>
                      {i18n.t('entity.activityPanel.chat.mediaInChat')}
                    </WhatsappTextLink>
                  </Clickable>
                </Show>
                <Hide when={isNotNilOrEmpty(props.event.mediaId)}>
                  <RichContentDisplay
                    markdown={props.event.content}
                    ContentEditableComponent={<Text type="customer" />}
                  />
                </Hide>
              </div>
            </VStack>
          </Box>
        </HStack>
        <HStack width="100%" justify="space-between">
          <Space />
          <EventDate
            timestamp={props.event.createdAt}
            eventType={props.event.type as 'PLAIN' | 'WHATSAPP'}
            messageStatus={props.messageStatus}
            showReadStatus={props.showReadStatus ?? false}
          />
        </HStack>
      </VStack>
    </HStack>
  );
}
